angular.module('contactModule').component('contactPartialListings', {
	templateUrl: 'contactPartialListings/contactPartialListings.html',
	bindings: {
		listings: '<',
		isMobile: '<',
		formData: '<', 
		errorMessages: '<',
		manualSubmitted: '<',
		onListingSelected: '&'
	},
	controller: ['$timeout', '$window', 'PubSub', '$element', function($timeout, $window, PubSub, $element) {
		var ctrl = this;

		this.$onInit = () => {
			this.checkboxesListings = this.listings;
		};

		this.$postLink = () => {
	
		};


		this.isListingSelected = () => {
			let selectedListings = this.listings.filter(list => {
				return list.value;
			});

			if (selectedListings) {
				return true;
			}
			return false;
		};

		this.toggleValue = function(checkbox) {
			checkbox.value = !checkbox.value;

			
		};

	}]
});